import { HttpLink, split } from '@apollo/client'

import { API } from 'Config'
import Utils from 'Utils'

import { createWsLink } from './createWsLink'

export function createMainLink() {
  const isSubscription = Utils.ApolloClient.isSubscription

  const wsLink = createWsLink({ url: `${API.MAIN_WS}/graphql` })
  const httpLink = new HttpLink({ uri: `${API.MAIN_URL}/graphql` })

  return split(isSubscription, wsLink, httpLink)
}
